module.exports = __webpack_public_path__ + "img/威灵仙.cb0a9c03.jpg";